import { AppColors } from "@/styles/colors";
import { Checkbox, CheckboxGroup, Fieldset, HStack } from "@chakra-ui/react";
import { Control, FieldValues, useController } from "react-hook-form";

interface Props {
  control: Control<FieldValues>;
  name: string;
  items: string[];
  gap?: string;
  disabled?: boolean;
}

export const CustomCheckboxGroup = ({
  control,
  name,
  items,
  gap,
  disabled,
}: Props) => {
  const {
    field,
    formState: { errors },
  } = useController({
    name,
    control,
  });

  return (
    <Fieldset.Root
      invalid={!!errors?.[name]}
      data-testid="checkbox-group-fieldset"
    >
      <CheckboxGroup
        invalid={!!errors?.[name]}
        value={field.value}
        onValueChange={field.onChange}
        name={field.name}
        disabled={disabled}
        data-testid="checkbox-group"
      >
        <Fieldset.Content>
          <HStack display="flex" gap={gap} data-testid="checkbox-group-hstack">
            {items.map((value, index) => (
              <Checkbox.Root key={value} value={value}>
                <Checkbox.HiddenInput data-testid={`checkbox-${index}`} />
                <Checkbox.Control borderColor={AppColors.GRAY_BORDER_1} />
                <Checkbox.Label>{value}</Checkbox.Label>
              </Checkbox.Root>
            ))}
          </HStack>
        </Fieldset.Content>
      </CheckboxGroup>
    </Fieldset.Root>
  );
};
